module.exports = __webpack_public_path__ + "img/331d5d7cd830b8705f5a53490cded698.png";